import { ALTARSimpleDomainServiceException as __BaseException } from "./ALTARSimpleDomainServiceException";
export class BadRequestException extends __BaseException {
    constructor(opts) {
        super({
            name: "BadRequestException",
            $fault: "client",
            ...opts
        });
        this.name = "BadRequestException";
        this.$fault = "client";
        Object.setPrototypeOf(this, BadRequestException.prototype);
    }
}
export class ConflictException extends __BaseException {
    constructor(opts) {
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts
        });
        this.name = "ConflictException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ConflictException.prototype);
    }
}
export class DependencyException extends __BaseException {
    constructor(opts) {
        super({
            name: "DependencyException",
            $fault: "server",
            ...opts
        });
        this.name = "DependencyException";
        this.$fault = "server";
        Object.setPrototypeOf(this, DependencyException.prototype);
    }
}
export class ForbiddenException extends __BaseException {
    constructor(opts) {
        super({
            name: "ForbiddenException",
            $fault: "client",
            ...opts
        });
        this.name = "ForbiddenException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ForbiddenException.prototype);
    }
}
export class InternalServerException extends __BaseException {
    constructor(opts) {
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts
        });
        this.name = "InternalServerException";
        this.$fault = "server";
        Object.setPrototypeOf(this, InternalServerException.prototype);
    }
}
export class NotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "NotFoundException",
            $fault: "client",
            ...opts
        });
        this.name = "NotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, NotFoundException.prototype);
    }
}
export class UnauthorizedException extends __BaseException {
    constructor(opts) {
        super({
            name: "UnauthorizedException",
            $fault: "client",
            ...opts
        });
        this.name = "UnauthorizedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, UnauthorizedException.prototype);
    }
}
export const ValidationExceptionFieldFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var ValidationExceptionReason;
(function (ValidationExceptionReason) {
    ValidationExceptionReason["CANNOT_PARSE"] = "cannotParse";
    ValidationExceptionReason["FIELD_VALIDATION_FAILED"] = "fieldValidationFailed";
    ValidationExceptionReason["OTHER"] = "other";
    ValidationExceptionReason["UNKNOWN_OPERATION"] = "unknownOperation";
})(ValidationExceptionReason || (ValidationExceptionReason = {}));
export class ValidationException extends __BaseException {
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts
        });
        this.name = "ValidationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.reason = opts.reason;
        this.fieldList = opts.fieldList;
    }
}
export var IdentityRealm;
(function (IdentityRealm) {
    IdentityRealm["AMAZON"] = "Amazon";
    IdentityRealm["ID_PRISM"] = "LegalPassport";
})(IdentityRealm || (IdentityRealm = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["PERSON"] = "Person";
    IdentityType["TEAM"] = "Team";
})(IdentityType || (IdentityType = {}));
export const IdentityRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchDeleteAdvancedListItemAttachmentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var AdvancedListItemConstant;
(function (AdvancedListItemConstant) {
    AdvancedListItemConstant["EXTRA_TYPE"] = "Item";
})(AdvancedListItemConstant || (AdvancedListItemConstant = {}));
export const ItemChoiceOptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ItemHyperlinkFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityTypeRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityRepositoryRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityExtraRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityExtraVersionRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AdvancedListEventData_ITEM_WORKFLOW_EXECUTEDFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var AdvancedListEventData;
(function (AdvancedListEventData) {
    AdvancedListEventData.visit = (value, visitor) => {
        if (value.itemWorkflowExecuted !== undefined)
            return visitor.itemWorkflowExecuted(value.itemWorkflowExecuted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AdvancedListEventData || (AdvancedListEventData = {}));
export const AdvancedListEventDataFilterSensitiveLog = (obj) => {
    if (obj.itemWorkflowExecuted !== undefined)
        return { itemWorkflowExecuted: AdvancedListEventData_ITEM_WORKFLOW_EXECUTEDFilterSensitiveLog(obj.itemWorkflowExecuted)
        };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: 'UNKNOWN' };
};
export var AdvancedListEventType;
(function (AdvancedListEventType) {
    AdvancedListEventType["ITEM_WORKFLOW_EXECUTED"] = "item_workflow_executed";
})(AdvancedListEventType || (AdvancedListEventType = {}));
export const AdvancedListEventFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.eventData && { eventData: AdvancedListEventDataFilterSensitiveLog(obj.eventData)
    }),
});
export var AdvancedListWorkflowContextType;
(function (AdvancedListWorkflowContextType) {
    AdvancedListWorkflowContextType["ITEM_CREATED"] = "item_created";
    AdvancedListWorkflowContextType["ITEM_HEART_BEATED"] = "item_heart_beated";
    AdvancedListWorkflowContextType["ITEM_UPDATED"] = "item_updated";
})(AdvancedListWorkflowContextType || (AdvancedListWorkflowContextType = {}));
export const AdvancedListItemAttachmentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var FieldDefinitionDataType;
(function (FieldDefinitionDataType) {
    FieldDefinitionDataType["IdentityRef"] = "identityRef";
    FieldDefinitionDataType["boolean"] = "boolean";
    FieldDefinitionDataType["choice"] = "choice";
    FieldDefinitionDataType["date"] = "date";
    FieldDefinitionDataType["hyperlink"] = "hyperlink";
    FieldDefinitionDataType["multiIdentityRef"] = "multiIdentityRef";
    FieldDefinitionDataType["number"] = "number";
    FieldDefinitionDataType["sequence"] = "sequence";
    FieldDefinitionDataType["string"] = "string";
})(FieldDefinitionDataType || (FieldDefinitionDataType = {}));
export const AdvancedListItemFieldFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AdvancedListItemFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj._do_not_delete4 && { _do_not_delete4: AdvancedListEventFilterSensitiveLog(obj._do_not_delete4)
    }),
});
export const BatchDeleteAdvancedListItemAttachmentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: AdvancedListItemFilterSensitiveLog(obj.body)
    }),
});
export const SandboxFileKeyFileNameFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchUploadAdvancedListItemAttachmentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchUploadAdvancedListItemAttachmentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: AdvancedListItemFilterSensitiveLog(obj.body)
    }),
});
export const CreateAdvancedListItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateAdvancedListItemtResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: AdvancedListItemFilterSensitiveLog(obj.body)
    }),
});
export const DeleteAdvancedListItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadAdvancedListItemAttachmentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadAdvancedListItemAttachmentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexAdvancedListItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadAdvancedListItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadAdvancedListItemResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: AdvancedListItemFilterSensitiveLog(obj.body)
    }),
});
export const TermsAggregationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var JoinOperation;
(function (JoinOperation) {
    JoinOperation["AND"] = "And";
    JoinOperation["OR"] = "Or";
})(JoinOperation || (JoinOperation = {}));
export var ComparisonOperator;
(function (ComparisonOperator) {
    ComparisonOperator["CONTAINS"] = ":";
    ComparisonOperator["EQUALS"] = "=";
    ComparisonOperator["EXISTS"] = "exists";
    ComparisonOperator["GREATER_THAN"] = ">";
    ComparisonOperator["GREATER_THAN_OR_EQUAL"] = ">=";
    ComparisonOperator["LESS_THAN"] = "<";
    ComparisonOperator["LESS_THAN_OR_EQUAL"] = "<=";
    ComparisonOperator["NOT_CONTAIN"] = "!:";
    ComparisonOperator["NOT_EQUAL"] = "!=";
    ComparisonOperator["NOT_EXISTS"] = "not_exists";
})(ComparisonOperator || (ComparisonOperator = {}));
export const PropertyTokenFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const QueryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PaginationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SortFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchAdvancedListItemsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var AdvancedListItemSearchProperty;
(function (AdvancedListItemSearchProperty) {
    AdvancedListItemSearchProperty["KEYWORD_SEARCH"] = "body";
})(AdvancedListItemSearchProperty || (AdvancedListItemSearchProperty = {}));
export const AdvancedListSearchItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchAdvancedListItemsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnindexAdvancedListItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateAdvancedListItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateAdvancedListItemResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.body && { body: AdvancedListItemFilterSensitiveLog(obj.body)
    }),
});
export const ChoiceOptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AddFieldDefinitionInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateAdvancedListRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var AdvancedListConstant;
(function (AdvancedListConstant) {
    AdvancedListConstant["TYPE"] = "AdvancedList";
})(AdvancedListConstant || (AdvancedListConstant = {}));
export var ReservedFieldKey;
(function (ReservedFieldKey) {
    ReservedFieldKey["CreatedBy"] = "createdBy";
    ReservedFieldKey["CreatedDate"] = "createdDate";
    ReservedFieldKey["ID"] = "id";
    ReservedFieldKey["UpdatedBy"] = "updatedBy";
    ReservedFieldKey["UpdatedDate"] = "updatedDate";
})(ReservedFieldKey || (ReservedFieldKey = {}));
export const CreationInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeletionInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var ReservedVersion;
(function (ReservedVersion) {
    ReservedVersion["LATEST"] = "latest";
})(ReservedVersion || (ReservedVersion = {}));
export const EntityVersionRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const VersionInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FieldDefinitionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AdvancedListFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateAdvancedListResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteAdvancedListRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadAdvancedListRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadAdvancedListResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PublishAdvancedListEventRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.eventData && { eventData: AdvancedListEventDataFilterSensitiveLog(obj.eventData)
    }),
});
export const UpdateAdvancedListRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateAdvancedListResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateAdvancedListViewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var AdvancedListViewConstant;
(function (AdvancedListViewConstant) {
    AdvancedListViewConstant["EXTRA_TYPE"] = "View";
})(AdvancedListViewConstant || (AdvancedListViewConstant = {}));
export const AdvancedListViewFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateAdvancedListViewResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteAdvancedListViewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexAdvancedListViewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadAdvancedListViewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadAdvancedListViewResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchAdvancedListViewsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchAdvancedListViewsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnindexAdvancedListViewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateAdvancedListViewRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateAdvancedListViewResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AdvancedListItemContextFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AdvancedListWorkflowContextConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AdvancedListWorkflowExecutionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AdvancedListContextFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var EntityWorkflowConstants;
(function (EntityWorkflowConstants) {
    EntityWorkflowConstants["EXTRA_TYPE"] = "Workflow";
})(EntityWorkflowConstants || (EntityWorkflowConstants = {}));
export const VariableFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityWorkflowActorFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityWorkflowEvaluator_BasicFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var TimeUnit;
(function (TimeUnit) {
    TimeUnit["DAY"] = "day";
    TimeUnit["HOUR"] = "hour";
    TimeUnit["MINUTE"] = "minute";
    TimeUnit["MONTH"] = "month";
    TimeUnit["SECOND"] = "second";
    TimeUnit["WEEK"] = "week";
    TimeUnit["YEAR"] = "year";
})(TimeUnit || (TimeUnit = {}));
export const DurationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ActAdvancedListWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BuildAdvancedListWorkflowContextRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var BasicEntityWorkflowEvaluatorParams_VALUE_MATCHED;
(function (BasicEntityWorkflowEvaluatorParams_VALUE_MATCHED) {
    BasicEntityWorkflowEvaluatorParams_VALUE_MATCHED["CURRENT_ACTUAL_VALUE"] = "current_actual_value";
    BasicEntityWorkflowEvaluatorParams_VALUE_MATCHED["EXPECTED_VALUE"] = "expected_value";
    BasicEntityWorkflowEvaluatorParams_VALUE_MATCHED["PREVIOUS_ACTUAL_VALUE"] = "previous_actual_value";
})(BasicEntityWorkflowEvaluatorParams_VALUE_MATCHED || (BasicEntityWorkflowEvaluatorParams_VALUE_MATCHED = {}));
export var BasicEntityWorkflowEvaluatorParams_NUMBER_REACHED;
(function (BasicEntityWorkflowEvaluatorParams_NUMBER_REACHED) {
    BasicEntityWorkflowEvaluatorParams_NUMBER_REACHED["CURRENT_NUMBER"] = "current_number";
    BasicEntityWorkflowEvaluatorParams_NUMBER_REACHED["OFFSET"] = "offset";
    BasicEntityWorkflowEvaluatorParams_NUMBER_REACHED["TARGET_NUMBER"] = "target_number";
})(BasicEntityWorkflowEvaluatorParams_NUMBER_REACHED || (BasicEntityWorkflowEvaluatorParams_NUMBER_REACHED = {}));
export var BasicEntityWorkflowEvaluatorType;
(function (BasicEntityWorkflowEvaluatorType) {
    BasicEntityWorkflowEvaluatorType["DATE_CADENCE_REACHED"] = "date_cadence_reached";
    BasicEntityWorkflowEvaluatorType["DATE_REACHED"] = "date_reached";
    BasicEntityWorkflowEvaluatorType["EMPLOYEE_VALIDATION"] = "employee_validation";
    BasicEntityWorkflowEvaluatorType["NUMBER_REACHED"] = "number_reached";
    BasicEntityWorkflowEvaluatorType["VALUE_CHANGED"] = "value_changed";
    BasicEntityWorkflowEvaluatorType["VALUE_MATCHED"] = "value_matched";
    BasicEntityWorkflowEvaluatorType["VALUE_SET"] = "value_set";
})(BasicEntityWorkflowEvaluatorType || (BasicEntityWorkflowEvaluatorType = {}));
export var BasicEntityWorkflowActorType;
(function (BasicEntityWorkflowActorType) {
    BasicEntityWorkflowActorType["ECHO"] = "echo";
    BasicEntityWorkflowActorType["EMAIL"] = "email";
})(BasicEntityWorkflowActorType || (BasicEntityWorkflowActorType = {}));
export var BasicEntityWorkflowActorParams_EMAIL;
(function (BasicEntityWorkflowActorParams_EMAIL) {
    BasicEntityWorkflowActorParams_EMAIL["BODY"] = "body";
    BasicEntityWorkflowActorParams_EMAIL["CC_LIST"] = "cc_list";
    BasicEntityWorkflowActorParams_EMAIL["SUBJECT"] = "subject";
    BasicEntityWorkflowActorParams_EMAIL["TO_LIST"] = "to_list";
})(BasicEntityWorkflowActorParams_EMAIL || (BasicEntityWorkflowActorParams_EMAIL = {}));
export const BasicEntityWorkflowActorOutput_EMAILFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var BasicEntityWorkflowActorParams_ECHO;
(function (BasicEntityWorkflowActorParams_ECHO) {
    BasicEntityWorkflowActorParams_ECHO["MESSAGE"] = "message";
})(BasicEntityWorkflowActorParams_ECHO || (BasicEntityWorkflowActorParams_ECHO = {}));
export var BasicEntityWorkflowEvaluatorParams_EMPLOYEE_VALIDATION;
(function (BasicEntityWorkflowEvaluatorParams_EMPLOYEE_VALIDATION) {
    BasicEntityWorkflowEvaluatorParams_EMPLOYEE_VALIDATION["EMPLOYEE_LOGIN"] = "employee_login";
    BasicEntityWorkflowEvaluatorParams_EMPLOYEE_VALIDATION["EMPLOYEE_VALID_STATUS"] = "employee_valid_status";
    BasicEntityWorkflowEvaluatorParams_EMPLOYEE_VALIDATION["LAST_VALIDATED_DATE"] = "last_validated_date";
})(BasicEntityWorkflowEvaluatorParams_EMPLOYEE_VALIDATION || (BasicEntityWorkflowEvaluatorParams_EMPLOYEE_VALIDATION = {}));
export var BasicEntityWorkflowEvaluatorParams_DATE_CADENCE_REACHED;
(function (BasicEntityWorkflowEvaluatorParams_DATE_CADENCE_REACHED) {
    BasicEntityWorkflowEvaluatorParams_DATE_CADENCE_REACHED["BEGIN_DATE"] = "begin_date";
    BasicEntityWorkflowEvaluatorParams_DATE_CADENCE_REACHED["CURRENT_DATE"] = "current_date";
    BasicEntityWorkflowEvaluatorParams_DATE_CADENCE_REACHED["INTERVAL"] = "interval";
    BasicEntityWorkflowEvaluatorParams_DATE_CADENCE_REACHED["INTERVAL_UNIT"] = "interval_unit";
    BasicEntityWorkflowEvaluatorParams_DATE_CADENCE_REACHED["LAST_REACHED_DATE"] = "last_reached_date";
})(BasicEntityWorkflowEvaluatorParams_DATE_CADENCE_REACHED || (BasicEntityWorkflowEvaluatorParams_DATE_CADENCE_REACHED = {}));
export var BasicEntityWorkflowEvaluatorParams_DATE_REACHED;
(function (BasicEntityWorkflowEvaluatorParams_DATE_REACHED) {
    BasicEntityWorkflowEvaluatorParams_DATE_REACHED["CURRENT_DATE"] = "current_date";
    BasicEntityWorkflowEvaluatorParams_DATE_REACHED["LAST_REACHED_DATE"] = "last_reached_date";
    BasicEntityWorkflowEvaluatorParams_DATE_REACHED["OFFSET"] = "offset";
    BasicEntityWorkflowEvaluatorParams_DATE_REACHED["OFFSET_TIME_UNIT"] = "offset_time_unit";
    BasicEntityWorkflowEvaluatorParams_DATE_REACHED["TARGET_DATE"] = "target_date";
})(BasicEntityWorkflowEvaluatorParams_DATE_REACHED || (BasicEntityWorkflowEvaluatorParams_DATE_REACHED = {}));
export var BasicEntityWorkflowEvaluatorParams_VALUE_CHANGED;
(function (BasicEntityWorkflowEvaluatorParams_VALUE_CHANGED) {
    BasicEntityWorkflowEvaluatorParams_VALUE_CHANGED["NEW_VALUE"] = "new_value";
    BasicEntityWorkflowEvaluatorParams_VALUE_CHANGED["OLD_VALUE"] = "old_value";
})(BasicEntityWorkflowEvaluatorParams_VALUE_CHANGED || (BasicEntityWorkflowEvaluatorParams_VALUE_CHANGED = {}));
export const CreateAdvancedListWorkflowExecutionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var EntityWorkflowExecutionConstants;
(function (EntityWorkflowExecutionConstants) {
    EntityWorkflowExecutionConstants["EXTRA_TYPE"] = "WorkflowExecution";
})(EntityWorkflowExecutionConstants || (EntityWorkflowExecutionConstants = {}));
export var EntityWorkflowExecutionStatus;
(function (EntityWorkflowExecutionStatus) {
    EntityWorkflowExecutionStatus["CONTEXT_CREATION_FAILED"] = "context_creation_failed";
    EntityWorkflowExecutionStatus["CONTEXT_CREATION_SUCCEEDED"] = "context_creation_succeeded";
    EntityWorkflowExecutionStatus["CREATED"] = "created";
    EntityWorkflowExecutionStatus["EVALUATION_FAILED"] = "evaluation_failed";
    EntityWorkflowExecutionStatus["EVALUATION_SUCCEEDED"] = "evaluation_succeeded";
    EntityWorkflowExecutionStatus["FAILED"] = "FAILED";
    EntityWorkflowExecutionStatus["STARTED"] = "started";
    EntityWorkflowExecutionStatus["SUCCEEDED"] = "succeeded";
})(EntityWorkflowExecutionStatus || (EntityWorkflowExecutionStatus = {}));
export const EntityWorkflowExecutionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateAdvancedListWorkflowExecutionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateAdvancedListWorkflowExecutionByItemRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EvaluateAdvancedListWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadAdvancedListWorkflowExecutionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadAdvancedListWorkflowExecutionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RunAdvancedListWorkflowExecutionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RunAdvancedListWorkflowExecutionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchAdvancedListWorkflowExecutionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityWorkflowExecutionSearchItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchAdvancedListWorkflowExecutionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteAdvancedListWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const LoadAdvancedListWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchAdvancedListWorkflowRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityWorkflowSearchItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchAdvancedListWorkflowResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateEntityRelationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var EntityRelationConstant;
(function (EntityRelationConstant) {
    EntityRelationConstant["TYPE"] = "EntityRelation";
})(EntityRelationConstant || (EntityRelationConstant = {}));
export var EntityRelationPermissionExtraIdConstant;
(function (EntityRelationPermissionExtraIdConstant) {
    EntityRelationPermissionExtraIdConstant["CREATE"] = "Create";
})(EntityRelationPermissionExtraIdConstant || (EntityRelationPermissionExtraIdConstant = {}));
export const EntityRelationInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateEntityRelationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteEntityRelationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetEntityRelationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetEntityRelationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexEntityRelationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchEntityRelationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchEntityRelationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var Module;
(function (Module) {
    Module["LEGAL_CONSOLE"] = "LegalConsole";
    Module["PAT"] = "PAT";
    Module["PATHFINDER"] = "PathFinder";
    Module["RAPINI"] = "RAPINI";
    Module["SDT"] = "SDT";
    Module["SOURCE"] = "Source";
})(Module || (Module = {}));
export const CreateInstanceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityRepositoryVersionRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityRepositoryInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterCustomFieldType;
(function (MatterCustomFieldType) {
    MatterCustomFieldType["DATE"] = "Date";
})(MatterCustomFieldType || (MatterCustomFieldType = {}));
export const MatterCustomFieldFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterInstanceWorkflowRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const Source2ModuleConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ModuleConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InstancePayloadFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateInstanceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInstanceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInstanceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetUserAllowedTeamsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InstanceAllowedTeamRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InstanceRoleRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InstanceAllowedTeamInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetUserAllowedTeamsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetUserRolesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityRepositoryRolePermissionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InstanceRoleInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetUserRolesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateInstanceAllowedTeamRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateInstanceAllowedTeamResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteInstanceAllowedTeamRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInstanceAllowedTeamRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInstanceAllowedTeamResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchInstanceAllowedTeamRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchInstanceAllowedTeamResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateInstanceAllowedTeamRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateInstanceAllowedTeamResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateInstanceAuthzRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InstanceAuthzRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InstanceAuthzInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateInstanceAuthzResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteInstanceAuthzRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteInstanceAuthzResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInstanceAuthzRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInstanceAuthzResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchInstanceAuthzRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchInstanceAuthzResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateInstanceRoleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateInstanceRoleResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchOpreationInstanceResourceFilterSensitiveLog = (obj) => ({
    ...obj,
});
export class BatchOperationInstanceResourceException extends __BaseException {
    constructor(opts) {
        super({
            name: "BatchOperationInstanceResourceException",
            $fault: "client",
            ...opts
        });
        this.name = "BatchOperationInstanceResourceException";
        this.$fault = "client";
        Object.setPrototypeOf(this, BatchOperationInstanceResourceException.prototype);
        this.succeeded = opts.succeeded;
        this.failed = opts.failed;
    }
}
export const DeleteInstanceRoleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteInstanceRoleResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInstanceRoleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInstanceRoleResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchInstanceRoleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchInstanceRoleResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateInstanceRoleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateInstanceRoleResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GenInstanceSandboxFileGetUrlRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GenInstanceSandboxFileGetUrlResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GenInstanceSandboxFilePutUrlRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GenInstanceSandboxFilePutUrlResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteUserItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var UserItemConstants;
(function (UserItemConstants) {
    UserItemConstants["EXTRA_TYPE"] = "UserItem";
})(UserItemConstants || (UserItemConstants = {}));
export const UserItemInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteUserItemOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetUserItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetUserItemOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexUserItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutUserItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutUserItemOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchUserItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchUserItemOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnindexUserItemInputFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IsAuthorizedRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IsAuthorizedResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchInstanceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchInstanceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var SmartSearchResultRelevanceType;
(function (SmartSearchResultRelevanceType) {
    SmartSearchResultRelevanceType["NOT_RELEVANT"] = "NOT_RELEVANT";
    SmartSearchResultRelevanceType["RELEVANT"] = "RELEVANT";
})(SmartSearchResultRelevanceType || (SmartSearchResultRelevanceType = {}));
export const SmartSearchResultRelevanceItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SmartSearchResultFeedbackRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateInstanceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateInstanceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateLabelRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var LabelConstant;
(function (LabelConstant) {
    LabelConstant["TYPE"] = "Label";
})(LabelConstant || (LabelConstant = {}));
export const LabelInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateLabelResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLabelRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLabelResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexLabelRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchLabelRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchLabelResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateLabelRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateLabelResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SubLocationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CountryData2FilterSensitiveLog = (obj) => ({
    ...obj,
});
export var LocationType;
(function (LocationType) {
    LocationType["COUNTRY"] = "Country";
    LocationType["UNION"] = "Union";
})(LocationType || (LocationType = {}));
export const UnionData2FilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateLocationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var LocationConstant;
(function (LocationConstant) {
    LocationConstant["TYPE"] = "Location";
})(LocationConstant || (LocationConstant = {}));
export const LocationDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateLocationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLocationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLocationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexLocationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchLocationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchLocationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpateLocationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateLocationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterRefFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterChatLastReadMessageVersionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterLastReadMessageConstant;
(function (MatterLastReadMessageConstant) {
    MatterLastReadMessageConstant["ITEM_TYPE"] = "MATTER_LAST_READ_MESSAGE_TYPE";
})(MatterLastReadMessageConstant || (MatterLastReadMessageConstant = {}));
export const MatterChatLastReadMessageItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterChatLastReadMessageVersionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexMatterChatLastReadRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexMatterChatMessageRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const NestedQueryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterChatLastReadMessageRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterChatLastReadMessageResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterChatMessageRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterChatMessageSearchItemFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SearchMatterChatMessageResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SendMatterChatMessageRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterChatMessageConstant;
(function (MatterChatMessageConstant) {
    MatterChatMessageConstant["EXTRA_TYPE"] = "matter-chat-message";
})(MatterChatMessageConstant || (MatterChatMessageConstant = {}));
export const MatterChatMessageFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SendMatterChatMessageResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterChatLastReadMessageVersionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateMatterChatLastReadMessageVersionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMatterDraftContentClientFacingFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterFileFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMatterDraftContentClientFacingFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadMatterDraftContentClientFacingFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadMatterDraftContentClientFacingFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadMatterPublishedClientFacingFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DownloadMatterPublishedClientFacingFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterDraftContentClientFacingFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var EntityAttachmentConstant;
(function (EntityAttachmentConstant) {
    EntityAttachmentConstant["EXTRA_TYPE"] = "EntityAttachment";
})(EntityAttachmentConstant || (EntityAttachmentConstant = {}));
export const EntityExtraInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EntityAttachmentInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export var MatterDraftContentFileType;
(function (MatterDraftContentFileType) {
    MatterDraftContentFileType["CLIENT_FACING"] = "clientFacing";
    MatterDraftContentFileType["LEGAL_ONLY"] = "legalOnly";
})(MatterDraftContentFileType || (MatterDraftContentFileType = {}));
export const MatterDraftContentFileInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterDraftContentClientFacingFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedClientFacingFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetMatterPublishedClientFacingFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UploadMatterDraftContentClientFacingFileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UploadMatterDraftContentClientFacingFileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateMatterDraftContentClientFacingFolderRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MatterFolderFilterSensitiveLog = (obj) => ({
    ...obj,
});
